import React, {useEffect, useState} from 'react';
import "./cartPage.scss";
import {useParams} from "react-router-dom";
import OrderMainFoodPath from "../../sections/orderMainFoodSection/components/OrderMainFoodPath";
import OrderHeadSectionComponent from "../../components/headSection/components/OrderHeadSectionComponent";
import ContactSectionComponent from "../main/sections/contactSection/ContactSectionComponent";
import OrderTotalPrice from '../../sections/orderMainSection/components/OrderTotalPrice';
import SearchedRealatedProduct from '../../sections/orderMainSection/components/SearchedRealatedProduct';
import { useDispatch, useSelector } from "react-redux";
import { AddMealToCart, GetUserCart } from "../../api/useMeal";
import { setUserValue } from "../../reducers/userReducer";

const getCategoryName = (category: string) => {
    const words = category.split("-");
    if (words.length === 1) {
        return words[0].charAt(0).toUpperCase() + words[0].slice(1);
    } else {
        const firstWord = words[0];
        const restOfWords = words.slice(1).join(" ");
        return firstWord.charAt(0).toUpperCase() + firstWord.slice(1) + " " + restOfWords;
    }
}

const CartPage = () => {
    const user = useSelector((state: any) => state.user);
    const {category, details, order} = useParams();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    
    useEffect (() => {
        const getCartData = async () => {
            try {
                if (user && user.id) {
                    setLoading(true);
                    const result = await GetUserCart(user.id);
                    
                    console.log("result: ", result);
                    
                    if (result) {
                        dispatch(setUserValue({ key: "cartCount", value: result.meals.length }));
                        setLoading(false);
                    } else {
                        dispatch(setUserValue({ key: "cartCount", value: 0 }));
                    }
                }
            } catch (e) {
                console.error(e);
            } finally {
                setLoading(false);
            }
        }
        
        getCartData().then(() => setLoading(false));
    }, [user]);
    
    /*
    * <>
            <OrderHeadSectionComponent />
            <div className="orderMainSectionComponent__container">
                <OrderMainFoodPath
                    path={["Cart"]}
                    selectedCategory={category ? getCategoryName(category) : ""}
                />
                    <OrderTotalPrice/>
                <div className="orderMainSectionComponent__container-content-searched-realated-product">
                    <SearchedRealatedProduct />
                </div>
                <div className="orderMainSectionComponent__container-content-contact">
                    <ContactSectionComponent />
                </div>
            </div>
        </>
    *  */
    
    return (
      <div className="cartPage">
            <OrderHeadSectionComponent />
            <div className="cartPage__container">
                <OrderMainFoodPath
                    path={["Cart"]}
                    selectedCategory={category ? getCategoryName(category) : ""}
                />
                
                <div className="cartPage__container_content">
                    <OrderTotalPrice/>
                </div>
                <div className="cartPage__container_searchedProduct">
                    <SearchedRealatedProduct />
                </div>
                <div className="cartPage__container_contact">
                    <ContactSectionComponent />
                </div>
            </div>
        </div>
    );
};

export default CartPage;